import { Injectable } from "@angular/core";
import { environment } from "@env";
import { ContactCenterContent, ContactCenterData, ContactFormContent, ContactFormData, DisclaimerContent, DisclaimerData, HeaderContent, HeaderData } from "@interfaces/contactForm.interface";


@Injectable({
    providedIn: 'root'
})
export class CmsUtils {
    constructor() {}

    public mapFormContact(item: ContactFormData): ContactFormContent {
        const formContactData: ContactFormContent = {
            formTitle: item.titulo_formulario,
            formDescription: item.descripcion_formulario,
            altImage: item.alt_image,
            backButtonText: item.texto_boton_volver,
            sendButtonText: item.texto_boton_enviar,
            safeSiteText: item.texto_sitio_seguro,
            image: `${environment.cmsApiUrl}assets/${item.imagen.filename_disk}`  
        };
        return formContactData;
    }

    public mapContactCenter(item: ContactCenterData): ContactCenterContent {
        const contactCenter: ContactCenterContent = {
            contactTitle: item.texto_contact_center,
            contactNumber: item.numero_contact_center
        };
        return contactCenter;
    }

    public mapHeaderContent(item: HeaderData): HeaderContent {
        const headerContent: HeaderContent = {
            firstLine: item.titulo_banner_l1,
            secondLine: item.titulo_banner_l2
        };
        return headerContent;
    }

    public mapDisclaimerContent(item: DisclaimerData): DisclaimerContent {
        const disclaimerContent: DisclaimerContent = {
            disclaimerTitle: item.titulo_disclaimer,
            disclaimerText: item.disclaimer,
        };
        return disclaimerContent;
    }
}
